import type { WorkspaceDoc } from '@/lib/sync/entity-types';

/**
 * Filter the document list for the nula-link picker.
 *
 * Excludes:
 *  - the CURRENT document — a self-link would mount the doc's own
 *    EntityPreviewCard/DocumentViewer against the same Yjs doc on hover, which
 *    corrupts the live document. Preventing self-links here is the root-cause
 *    fix.
 *  - archived documents.
 * Then matches the title against the (case-insensitive) query and caps results.
 */
export function filterPickerDocs(
  docs: readonly WorkspaceDoc[],
  query: string,
  currentEntityId: string,
  limit = 50,
): WorkspaceDoc[] {
  const q = query.trim().toLowerCase();
  const base = docs.filter((d) => d.id !== currentEntityId && !d.isArchived);
  const matched = q
    ? base.filter((d) => (d.title || 'Untitled').toLowerCase().includes(q))
    : base;
  return matched.slice(0, limit);
}
